import { Button } from "@/components/ui/button"
import { DropdownMenu } from "@/components/ui/dropdown-menu"

import { StatsName } from "../types"
import { Tooltip } from "@/components/ui/tooltip"

/**
 * dictionary src/dictionaries/en/components/trackings.json
 */
const dictionary = createContextMapper("components", "trackings", "stats")

/**
 * StatsSelector
 */
export const StatsSelector: React.FC<{
  stats: StatsName
  setStats: (stats: StatsName) => void
}> = ({ stats, setStats }) => {
  const { _ } = useDictionary(dictionary())
  const list: StatsName[] = ["visit", "os", "device", "browser"]
  return (
    <div className="flex gap-4 items-center">
      <DropdownMenu>
        <Tooltip content={_("tooltip")} side="bottom">
          <DropdownMenu.Trigger asChild>
            <Button variant="outline" size="xs">
              {_(stats)}
            </Button>
          </DropdownMenu.Trigger>
        </Tooltip>
        <DropdownMenu.Content align="end" side="bottom" className="w-56">
          {A.map(list, item => (
            <DropdownMenu.Item onClick={() => setStats(item)} active={stats === item} key={item}>
              {_(item)}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu>
    </div>
  )
}
